import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';

import { Account } from '../entities/account';

import * as AuthActions from './auth.actions';

export const featureKey = 'auth';

export interface AuthState {
    token: string | null;
    isAuthenticated: boolean;
    loading: boolean;
    error: HttpErrorResponse | null;
    account: Account | null;
    accountInitiallyRequested: boolean;
    urlAfterLogin?: string;
}

const initialState: AuthState = {
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    account: null,
    accountInitiallyRequested: false
};

export const reducer = createReducer(
    initialState,
    on(AuthActions.checkAuthentication, (state) => ({ ...state, loading: true })),
    on(AuthActions.setAccount, (state, { account }) => ({ ...state, account, loading: false })),
    on(AuthActions.setToken, (state, { token }) => ({ ...state, token })),
    on(AuthActions.setIsAuthenticated, (state, { isAuthenticated }) => ({ ...state, isAuthenticated })),
    on(AuthActions.register, (state) => ({ ...state, loading: true, error: null })),
    on(AuthActions.authenticate, (state) => ({ ...state, loading: true, error: null })),
    on(AuthActions.authenticationSuccess, (state) => ({ ...state, loading: false })),
    on(AuthActions.authenticationFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(AuthActions.accountInitiallyRequested, (state) => ({ ...state, accountInitiallyRequested: true })),
    on(AuthActions.navigateToLogin, (state, { url }) => ({ ...state, urlAfterLogin: url })),
    on(AuthActions.logout, (state) => ({
        ...state,
        isAuthenticated: false,
        account: null,
        token: null
    }))
);
